import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { ArrowBack, ArrowForward, Edit } from "@material-ui/icons";
const icons = {
    ArrowForward: _jsx(ArrowForward, {}),
    ArrowBack: _jsx(ArrowBack, {}),
    Edit: _jsx(Edit, {}),
    Blank: _jsx(_Fragment, {})
};
export default icons;
//# sourceMappingURL=Icons.js.map